import { IRootState } from '../../../store'
import { ISigner } from '../store/completeChart.types'

export const getSignerSelector = (state: IRootState): ISigner | null => state.signerData.signer
